/**
 * assets/partner-collection.js
 * Gedrag van sections/partner-collection.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function(){
  var btns = document.querySelectorAll('.pp-koi-filter');
  var cards = document.querySelectorAll('.pp-koi-card');
  var empty = document.getElementById('pp-koi-empty');
  btns.forEach(function(b){
    b.addEventListener('click', function(){
      btns.forEach(function(x){ x.classList.remove('is-active','bg-navy','text-white'); x.classList.add('bg-white','text-navy'); });
      b.classList.add('is-active','bg-navy','text-white'); b.classList.remove('bg-white','text-navy');
      var s = b.getAttribute('data-soort'); var shown=0;
      cards.forEach(function(c){
        var ok = s==='all' || c.getAttribute('data-soort')===s;
        c.style.display = ok ? '' : 'none'; if(ok) shown++;
      });
      if(empty) empty.classList.toggle('hidden', shown>0);
    });
  });
  function applyUrlFilter(){
    var params=new URLSearchParams(location.search); var active=null,val=null;
    ['soort','kwekerij','leeftijd','maat'].forEach(function(p){ if(params.get(p)){ active=p; val=params.get(p); } });
    if(!active) return;
    var attr = active==='soort' ? 'data-soortx' : ('data-'+active);
    var shown=0; cards.forEach(function(c){ var ok=c.getAttribute(attr)===val; c.style.display=ok?'':'none'; if(ok)shown++; });
    var banner=document.getElementById('pp-active-filter');
    if(banner){ document.getElementById('pp-filter-label').textContent=val.replace(/-/g,' '); banner.classList.remove('hidden'); }
    if(empty) empty.classList.toggle('hidden', shown>0);
  }
  var reset=document.getElementById('pp-filter-reset');
  if(reset) reset.addEventListener('click', function(){ cards.forEach(function(c){ c.style.display=''; }); document.getElementById('pp-active-filter').classList.add('hidden'); if(empty) empty.classList.add('hidden'); history.replaceState(null,'',location.pathname); });
  applyUrlFilter();
})();
